import axios, { AxiosInstance } from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Form, Image, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import "./App.css";
import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import useSound from "use-sound";
import ConfettiExplosion from "react-confetti-explosion";

function App() {
	var client: AxiosInstance = axios.create({
		baseURL: "https://gate.dopple.site/open/",
		headers: {
			"Access-Control-Allow-Cross-Origin": "*",
			"Content-Type": "application/json",
		},
	});

	const navigate = useNavigate();
	const expires: Date = new Date(Date.now());
	const month = 1000 * 60 * 60 * 24 * 30; // 30 days
	expires.setTime(expires.getTime() + month);

	// const cookies = new Cookies(null, { path: "/", expires: expires });
	const [activeGlow, setActiveGlow] = useState<string | null>(null);

	const queryParameters = new URLSearchParams(window.location.search);
	const door = queryParameters.get("door");
	const automatic = queryParameters.get("automatic");
	// var pin = cookies.get("doorpin");

	const [play_gate_sound] = useSound("/sounds/opening_gate.wav");
	const [play_achterdeur_sound] = useSound("/sounds/success.mp3");
	const [play_glazendeur_sound] = useSound("/sounds/glass.mp3");

	// Temporary fallback for switching from localStorage to a cookie (JumJum)
	var pin = localStorage.getItem("doorpin");
	if (!pin) {
		pin = localStorage.getItem("doorpin");
		if (!pin)
			pin = queryParameters.get('pin')
	}

	const [explosion, setExplosion] = useState<"voordeur" | "achterdeur" | "glazendeur" | "poort" | "none">("none");

	function handleSubmit(event: any) {
		event.preventDefault();

		const doorName = event.target.id;
		const pinCode = event.target.form.pin.value;
		// cookies.set("doorpin", pinCode);
		toast.loading("Sending pin...");
		localStorage.setItem("doorpin", pinCode);
		client.get(`${doorName}/${pinCode}`).then((response) => {
			if (response.data.error === "PIN_INCORRECT") toast.error(`Unlock unsuccessful`);
			else if (response.data.error === "NOT_ALLOWED") toast.error("Unlock not allowed");
			else if (response.data.error) toast.error(`${response.data.error}`);
			else {
				setActiveGlow(doorName);

				setTimeout(() => {
					setActiveGlow(null);
				}, 2000);


				if (doorName === "poort") {
					play_gate_sound();
					setExplosion(doorName)
				}

				if (doorName === "achterdeur") {
					play_achterdeur_sound();
					setExplosion(doorName)
				}

				if (doorName === "glazendeur") {
					play_glazendeur_sound();
					setExplosion(doorName)
				}
				if (doorName === "voordeur") {
					setExplosion(doorName)
				}
				toast.success(`${response.data.info}`);
				navigate(`?door=${doorName}`);
			}
		});
	}

	useEffect(() => {
		if (automatic && door && pin) {
			client.get(`${door}/${pin}`).then((response) => {
				if (response.data.error === "PIN_INCORRECT") toast.error(`Unlock unsuccessful`);
				else if (response.data.error === "NOT_ALLOWED") toast.error("Unlock not allowed");
				else if (response.data.error) toast.error(`${response.data.error}`);
				else {
					if (door === "poort") {
						play_gate_sound();
					}

					if (door === "achterdeur") {
						play_achterdeur_sound();
					}

					if (door === "glazendeur") {
						play_glazendeur_sound();
					}
					toast.success(`${response.data.info}`);
					navigate(`?door=${door}`);
				}
			});
		}
	}, [automatic, client, door, navigate, pin, play_achterdeur_sound, play_gate_sound, play_glazendeur_sound]);

	return (
		<div className="App">
			<header className="App-header">
				<div className="glass-card">
					<Image
						style={{ paddingRight: '18px' }}
						width={300}
						src="/DoppleLogoGray.png"
					></Image>
					<br />
					<br />
					<br />
					<br />
					<Form>
						<p className="subtitle">Enter your pin</p>
						<Form.Control
							className="glass-input"
							style={{ fontSize: "16px" }}
							autoComplete="current-password"
							type="password"
							id="pin"
							defaultValue={pin ? pin : ""}
						></Form.Control>
						<Col className="button-grid">
							<Button
								className={`glass-btn ${activeGlow === "poort" ? "glow-poort" : ""}`}
								size="lg"
								id="poort"
								onClick={handleSubmit}
							>
								Poort
							</Button>
							<Button
								className={`glass-btn ${activeGlow === "achterdeur" ? "glow-achterdeur" : ""}`}
								size="lg"
								id="achterdeur"
								onClick={handleSubmit}
							>
								Achterdeur
							</Button>
							<Button
								className={`glass-btn ${activeGlow === "glazendeur" ? "glow-glazendeur" : ""}`}
								size="lg"
								id="glazendeur"
								onClick={handleSubmit}
							>
								Glazendeur
							</Button>
							<Button
								className={`glass-btn ${activeGlow === "voordeur" ? "glow-voordeur" : ""}`}

								size="lg"
								id="voordeur"
								onClick={handleSubmit}
							>
								Voordeur
							</Button>
						</Col>
					</Form>
				</div>
			</header>
		</div>
	);
}

export default App;
